// Interfaces
import clsx from "clsx";
import { ISideTreeTitleLabel } from "../interfaces";

// MUI
import { Stack, Typography } from "@mui/material";

export default function SideTreeLabelHeader(props: Readonly<ISideTreeTitleLabel>) {
	const {
		title = "",
		titleClasses = "",
		emptyTitle = "",
		emptyTitleClasses = "",
		treeProps = { loading: false },
		sx = null,
		isEmpty = () => {},
	} = props;

	if (!title && !emptyTitle) {
		return null;
	}

	const isEmptyReason = isEmpty(treeProps);
	const isLoading = treeProps?.loading;

	if (isLoading) {
		return null;
	}

	return (
		<Stack pl={"38px"} sx={sx}>
			{title && (
				<Stack>
					<Typography
						noWrap
						className={clsx({
							"!font-sans !text-[13px] pb-[5px] !text-neutral-gray": true,
							[titleClasses]: Boolean(titleClasses),
						})}
					>
						{title}
					</Typography>
				</Stack>
			)}
			{Boolean(emptyTitle && isEmptyReason) && (
				<Stack mt={"4px"}>
					<Typography
						noWrap
						className={clsx({
							"!font-sans !text-[14.5px] pb-[5px] !text-default": true,
							[emptyTitleClasses]: Boolean(emptyTitleClasses),
						})}
					>
						{emptyTitle}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
}
